import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { LoggingService, LoginService, VeterinarianLinkageRequestService } from '@pxl/models/contracts';
import {
    VeterinarianIdRequestBody,
    VeterinarianLinkageModel,
    VeterinarianLinkageRequestService as VeterinarianLinkageRequestBackendService,
} from '@pxl/shared/generated';
import { Observable } from 'rxjs';

@Injectable()
export class DefaultVeterinarianLinkageRequestService implements VeterinarianLinkageRequestService {
    private readonly loggingService = inject(LoggingService);
    private readonly veterinarianLinkageRequestServiceBackendService = inject(VeterinarianLinkageRequestBackendService);
    private readonly loginService = inject(LoginService);
    private readonly config = inject(CONFIG_TOKEN);

    public requestVeterinarianLinkage(body: VeterinarianIdRequestBody, veterinarianId: string): Observable<VeterinarianLinkageModel[]> {
        this.loggingService.debug('Requesting veterinarian linkage');
        return this.veterinarianLinkageRequestServiceBackendService.requestVeterinarianLinkage(
            body,
            this.config.API_VERSION,
            this.loginService.getToken(),
            veterinarianId,
        );
    }

    public getVeterinarianLinkageRequests(): Observable<Array<VeterinarianLinkageModel>> {
        this.loggingService.debug('Requesting veterinarian linkage requests');
        return this.veterinarianLinkageRequestServiceBackendService.getVeterinarianLinkageRequests(
            this.config.API_VERSION,
            this.loginService.getToken(),
        );
    }

    public revokeVeterinarianLinkageRequest(veterinarianLinkageId: string): Observable<void> {
        this.loggingService.debug('Revoking veterinarian linkage requests');
        return this.veterinarianLinkageRequestServiceBackendService.revokeVeterinarianLinkageRequest(
            veterinarianLinkageId,
            this.config.API_VERSION,
            this.loginService.getToken(),
        );
    }

    public getVeterinarianLinkageFeatureState(veterinarianId: string): Observable<boolean> {
        return this.veterinarianLinkageRequestServiceBackendService.getVeterinarianLinkageFeatureState(
            veterinarianId,
            this.config.API_VERSION,
        );
    }
}
